export const blockIconsActionSchedule = (
	<span className='material-symbols-outlined'>schedule</span>
);
